import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const VisibleIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.99996 2.8365C4.11043 2.80463 2.15621 4.1251 0.927621 5.47744C0.79866 5.62061 0.727295 5.80647 0.727295 5.99916C0.727295 6.19185 0.79866 6.37771 0.927621 6.52088C2.1295 7.84463 4.07809 9.19557 5.99996 9.16322C7.92184 9.19557 9.8709 7.84463 11.0737 6.52088C11.2027 6.37771 11.274 6.19185 11.274 5.99916C11.274 5.80647 11.2027 5.62061 11.0737 5.47744C9.84372 4.1251 7.8895 2.80463 5.99996 2.8365Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M7.75778 6.0001C7.75768 6.34774 7.65451 6.68755 7.4613 6.97656C7.2681 7.26557 6.99353 7.4908 6.67233 7.62377C6.35112 7.75674 5.9977 7.79149 5.65675 7.72361C5.31579 7.65573 5.00263 7.48828 4.75684 7.24242C4.51105 6.99657 4.34368 6.68336 4.27589 6.34239C4.20811 6.00142 4.24294 5.64801 4.376 5.32683C4.50906 5.00566 4.73436 4.73116 5.02342 4.53803C5.31249 4.3449 5.65232 4.24182 5.99996 4.24182C6.23086 4.24175 6.45951 4.28719 6.67283 4.37554C6.88616 4.46389 7.07998 4.59341 7.24323 4.7567C7.40648 4.91999 7.53594 5.11384 7.62423 5.32719C7.71252 5.54054 7.7579 5.7692 7.75778 6.0001Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default VisibleIcon;